<script setup lang="ts">
const { cart } = useCart();
</script>

<template>
  <div id="cart-items-desktop">
    <table>
      <thead>
        <tr>
          <th>Articles</th>
          <th>Quantité</th>
          <th>Sous-total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cartItem in cart.cart_items" :key="cartItem.key">
          <td>
            <div class="flex items-center gap-4">
              <ProductThumbnail :product="cartItem.product" class="shrink-0" />
              <div class="flex flex-col">
                <ProductName :product="cartItem.product" />
                <CartItemDetails :cart-item="cartItem" />
                <ProductPriceSimple v-if="cartItem.product.price" :product="cartItem.product" />
              </div>
            </div>
          </td>
          <td>
            <CartItemQuantity :cart-item="cartItem" />
          </td>
          <td class="relative w-32">
            <CartItemRemoveButton :cart-item="cartItem" class="absolute right-0 top-2" />
            <CartItemSubtotal :cart-item="cartItem" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="postcss">
#cart-items-desktop {
  table {
    @apply w-full;
  }
  thead {
    @apply font-bold;
  }
  tbody {
    @apply border-y-2 border-light divide-y-2 divide-light;
    td { @apply py-4; }
  }
  th, td {
    @apply text-center first:text-left last:text-right;
    &:not(:first-child, :last-child) {
      @apply px-4;
    }

  }
}
</style>
